import React, { useState, useEffect } from "react";
import Navbar from "../header/Navbar";
import Loader from "../../commonComponent/Loader";
import {
  deleteBlogService,
  getBlogListService,
} from "../../services/BlogService";
import BlogTableList from "./BlogTableList";
import { toastMsg } from "../../Utils/AllConstant";
import { showToastSuccess } from "../../Utils/Helper";

const BlogsDetailNew = () => {
  const [list, setList] = useState([]);
  const [showModal, setShowModal] = useState("");
  const [isLoading, setLoader] = useState(true);

  useEffect(() => {
    getBlogList();
  }, []);

  const getBlogList = async () => {
    try {
      const response = await getBlogListService();
      if (response) {
        setList(response.reverse());
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  // console.log(list , "post");
  const onDelete = async (post) => {
    try {
      const response = await deleteBlogService(post._id);
      if (response) {
        // showToast(toastMsg.deleteBlog)
        showToastSuccess(toastMsg.deleteBlog);
        const result = list.filter((item) => item._id !== post._id);
        setList(result);
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>

      <div className="row mt-2">
        <div className="table_resouter">
          <table class="table table-hover blogs_listscroll5">
            <thead>
              <tr>
                <td
                  className="py-4 text-muted "
                  style={{ width: "25%" }}
                  scope="col text-secondary"
                >
                  Blog Title
                </td>
                <td
                  className="py-4 text-muted text-center"
                  style={{ width: "12%" }}
                  scope="col text-secondary"
                >
                  Created Date
                </td>
                <td
                  className="py-4 text-muted text-center"
                  style={{ width: "15%" }}
                  scope="col text-secondary"
                >
                  Category
                </td>
                <td
                  className="py-4 text-muted text-center"
                  style={{ width: "10%" }}
                  scope="col text-secondary"
                >
                  Publish
                </td>

                <td
                  className="py-4 text-muted text-center"
                  style={{ width: "14%" }}
                  scope="col text-secondary"
                >
                  Publish Date
                </td>
                <td
                  className="py-4 text-muted text-center"
                  style={{ width: "10%" }}
                  scope="col text-secondary"
                >
                  Likes
                </td>
                <td
                  className="py-4 text-muted text-center"
                  style={{ width: "10%" }}
                  scope="col text-secondary"
                >
                  Views
                </td>
                <td
                  className="py-4 text-muted"
                  style={{ width: "4%" }}
                  scope="col text-secondary"
                ></td>
              </tr>
              <tr style={{ border: "1px solid white" }}>
                <td colSpan={8}>
                  <Loader
                    visible={isLoading}
                    emptyTextKey={!list?.length && "emptyBlog"}
                  />
                </td>
              </tr>
            </thead>

            {list.map((post, index) => (
              <BlogTableList
                showModal={showModal}
                onChangeModal={() =>
                  setShowModal(showModal !== post._id ? post._id : null)
                }
                key={index}
                index={index}
                post={post}
                onDelete={(data) => onDelete(data)}
                isLoading={isLoading}
              />
            ))}
          </table>
        </div>
      </div>
    </>
  );
};

export default BlogsDetailNew;
